import { useTranslation } from "react-i18next";

import { Badge, BadgeColors } from "@dotnet/telematics-design-system";

import { TASK_QUEUE } from "shared/types/enums";

import { QueueIconProps } from "./types";

const QueueIcon = ({ status }: QueueIconProps) => {
    const { t } = useTranslation();

    const getBadgeData = (statusName: TASK_QUEUE) => {
        switch (statusName) {
            case TASK_QUEUE.Executing:
                return { color: BadgeColors.info, isInverted: true };
            case TASK_QUEUE.Pending:
                return { color: BadgeColors.warning, isInverted: true };
            default:
                return { color: BadgeColors.neutral, isInverted: false };
        }
    };

    const color = getBadgeData(status).color;
    const isInverted = getBadgeData(status).isInverted;

    const name = t(`General##${status}`);

    return (
        <Badge color={color} inverted={isInverted}>
            {name}
        </Badge>
    );
};

export default QueueIcon;
